import Base2Repository from "./base2.repository";
import { GenericPersistence } from "core/data/persistence";
import { GenericService } from "core/data/service";

class LowStockReportRepository extends Base2Repository {
  getEntityIdentifier() {
    return "low-stock-report";
  }

  getPersistenceProvider() {
    return new GenericPersistence(this.getEntityIdentifier());
  }

  getServiceProvider() {
    return new GenericService({
      fetch: "/v1/low_stock_reports"
    });
  }
}

export default new LowStockReportRepository();



// WEBPACK FOOTER //
// ./src/core/repository/low-stock-report.repository.js